/** @format */

import React from "react";

import StoresContext from "@stores/context";
import StoresType from "@stores/types";

export const useStores = (): StoresType => React.useContext(StoresContext);
